import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { storesContext } from 'stores';
import CatalogCard from 'components/Catalog/Card';

/**
 * Wrapper for CatalogCard that adds progress information
 */
function ProgressCatalogCard(props) {
  const { entry } = props;
  const { progressStore } = useContext(storesContext);
  const found = progressStore.progressByCourse.find((c) => {
    const { course_code: courseCode } = c || {};
    return courseCode === entry.code;
  });

  // none is found...

  const { total_progress: totalProgress } = found || {};

  const progress = found ? Math.round(totalProgress * 100) : 0;

  return <CatalogCard course={entry} progress={progress} />;
}

ProgressCatalogCard.propTypes = {
  entry: PropTypes.object.isRequired,
};

export default observer(ProgressCatalogCard);
